import {
    LayoutDashboard, ClipboardList, FilePlus2, ListChecks, BarChart3, FileText,
    Wrench, FolderTree, Layers, Package, Tag, QrCode, Users, Building2, Network,
    UserCog, Settings, Briefcase, Store, UserRound
} from 'lucide-react';
import { RoleConstant } from '../../app/roleConstant';

// Menu igual ao Universo MOB (shell-web): sidebar por role, grupos colapsáveis.
// Espelha os menus originais do header.js.
const group = (key, label, icon, children) => ({ key, label, icon, children });

export function buildNav(role, lang) {
    const dashboard = { label: lang.dashboard, path: '/', icon: LayoutDashboard };
    const employees = { label: lang.employees, path: '/company-users', icon: Users };
    const settings = { label: lang.settings, path: '/config-system', icon: Settings };

    const osGroup = group('os', lang.os, ClipboardList, [
        { label: lang.register_new_os_abbreviated, path: '/create-os', icon: FilePlus2 },
        { label: lang.list_os_abbreviated, path: '/os', icon: ListChecks },
    ]);
    const reportsGroup = group('reports', lang.reports, BarChart3, [
        { label: lang.inspections, path: '/inspections', icon: FileText },
        { label: lang.maintenances, path: '/maintenances', icon: Wrench },
    ]);
    const registrationsGroup = group('registrations', lang.registrations, FolderTree, [
        { label: lang.categories, path: '/categories', icon: Layers },
        { label: lang.subcategories, path: '/subcategories', icon: Layers },
        { label: lang.products, path: '/products', icon: Package },
    ]);
    const tagsFull = group('tags', lang.tags, Tag, [
        { label: lang.list, path: '/tags', icon: Tag },
        { label: lang.generate_qr_code, path: '/tags-qr-code', icon: QrCode },
    ]);
    const tagsListOnly = group('tags', lang.tags, Tag, [
        { label: lang.list, path: '/tags', icon: Tag },
    ]);

    switch (role) {
        case RoleConstant.MOBCHECK_ADMIN:
        case RoleConstant.SERVICE_ADMIN:
            return [
                dashboard, osGroup, reportsGroup, registrationsGroup, tagsFull, employees,
                { label: lang.companies, path: '/companies', icon: Building2 },
                { label: lang.company_group, path: '/company-groups', icon: Network },
                group('bepi', 'Bepi Service', Briefcase, [
                    { label: 'Comercial', path: '/bepi/admin', icon: Briefcase },
                    { label: 'Oficina', path: '/bepi/workshop', icon: Store },
                    { label: 'Cliente', path: '/bepi/client', icon: UserRound },
                ]),
                { label: lang.all_users, path: '/users', icon: UserCog },
                settings,
            ];
        case RoleConstant.COMPANY_GROUP_ADMIN:
            return [
                dashboard, osGroup, reportsGroup, registrationsGroup, tagsFull, employees,
                { label: lang.userCompanies, path: '/user-companies', icon: Building2 },
                { label: lang.companies, path: '/companies', icon: Building2 },
                settings,
            ];
        case RoleConstant.COMPANY_ADMIN:
            return [dashboard, osGroup, reportsGroup, registrationsGroup, tagsFull, employees, settings];
        case RoleConstant.SERVICE_WORKSHOP:
            return [
                dashboard, osGroup, reportsGroup, registrationsGroup, tagsFull, employees, settings,
                group('bepi', 'Bepi Service', Briefcase, [
                    { label: 'Oficina', path: '/bepi/workshop', icon: Store },
                ]),
            ];
        case RoleConstant.COMPANY_OPERATOR:
            return [dashboard, reportsGroup, tagsListOnly];
        case RoleConstant.SERVICE_CLIENT:
            return [
                dashboard, reportsGroup, tagsListOnly,
                group('bepi', 'Bepi Service', Briefcase, [
                    { label: 'Cliente', path: '/bepi/client', icon: UserRound },
                ]),
            ];
        default:
            return [dashboard];
    }
}
